module.exports = __webpack_public_path__ + "static/img/ROUPS12V_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ROUPS12V_1.png
// module id = P/HI
// module chunks = 0